module.exports = __webpack_public_path__ + "static/duarte-52330f669d67d1837708e0c917e67dde.png";